module.exports = __webpack_public_path__ + "img/IMG_5002_L.bb7064eb.webp";